import Pagination from '../../../../shared/Pagination';
import paths from '../../../../config/local/paths';
import React, { useState } from 'react';
import useGetAdminVendors from '../../../../Hooks/Admin/Getters/useGetAdminVendors/useGetAdminVendors';
import VendorsTable from '../../../shared/Vendors/VendorsTable/VendorsTable';
import useIsGated from '../../../../Hooks/Shared/useIsGated/useIsGated';
import flags from '../../../../shared/Flags';
import GenericAdminVendors from './GenericAdminVendors';

/**
 * @param {{view: "domain" | "group"; isGated?: boolean}} props
 * @returns {JSX.Element}
 */
export default function AdminVendors(props) {
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	// vendors are unlocked for admins as long as at least one group has the subscription
	const gated = useIsGated(flags.vendor.add, { role: 'admin' });
	const vendors = useGetAdminVendors(
		props.view,
		currentPageNumber,
		gated.isGated
	);

	if (gated.isGated) {
		return <GenericAdminVendors />;
	}

	return (
		<React.Fragment>
			<VendorsTable
				editPath={paths.app.admin.offers.edit}
				isGettingData={vendors.isGettingData}
				vendors={vendors.data}
			/>

			<Pagination
				currentPageNumber={currentPageNumber}
				lastPageNumber={vendors.lastPageNumber}
				setCurrentPageNumber={setCurrentPageNumber}
			/>
		</React.Fragment>
	);
}
